"use strict";
/**
 * @author Maxim Seredkin
 */

import { EntityStatus } from "../enum/entityStatus";

export default [
  "$rootScope",
  "$scope",
  "ProjectGchpService",
  "ProjectGchpFilterService",
  "MilestoneService",
  "$utils",
  "IndustryService",
  "MunicipalityService",
  "$q",
  function (
    $rootScope,
    $scope,
    ProjectGchpService,
    ProjectGchpFilterService,
    MilestoneService,
    $utils,
    IndustryService,
    MunicipalityService,
    $q
  ) {
    // инициализация
    $scope.paginationSize = 15; //40;
    $scope.pagination = {
      search: "",
      isPaging: true,
      page: 1,
      size: $scope.paginationSize,
      totalPages: null,
      totalItems: null,
    };
    $scope.items = [];
    $scope.loading = false;
    $scope.refresh = refresh;
    $scope.municipalities = [];
    $scope.municipalitiesObject = {};
    $scope.industries = [];
    $scope.industriesObject = {};

    $scope.projectsCache = {};
    $scope.onVisible = (project) => {
      if ($scope.projectsCache[project.id]) return;
      requestProjectAdditionalInfo(project);
    };

    $scope.oneMorePage = oneMorePage;
    $scope.applyFilter = applyFilter;
    $scope.toggleFilter = toggleFilter;
    $scope.openFilter = $utils.openControlSidebar;
    $scope.openCreateProject = openCreateProject;

    init();

    function requestProjectAdditionalInfo(project) {
      $scope.projectsCache[project.id] = {
        ...project,
        metadata: {
          isLoadingProject: true,
          isLoadingFunds: true,
          isIntersectedProject: true,
        },
      };
      $q.all([
        ProjectGchpService.api.get({ projectId: project.id }).$promise,
        ProjectGchpService.api.okveds({ projectId: project.id }).$promise,
        ProjectGchpService.api.planFundsByYear({ projectId: project.id })
          .$promise,
      ]).then(([projectData, projectOkveds, projectPlanFundsByYear]) => {
        processDates(projectData._embedded);
        processFundsData(projectData._embedded, projectPlanFundsByYear);

        $scope.projectsCache[project.id] = {
          ...projectData._embedded,
          projectOkveds: projectOkveds._embedded,
          projectPlanFundsByYear: projectPlanFundsByYear._embedded,
          metadata: {
            isLoadingProject: false,
            isLoadingFunds: false,
            isIntersectedProject: true,
          },
        };
      });
    }

    function processFundsData(project, projectPlanFundsByYear) {
      const planFundDataFederal = projectPlanFundsByYear._embedded.length
        ? [
            projectPlanFundsByYear._embedded.map(
              (fund) => fund.federalBudget || 0
            ),
          ]
        : [0];
      const planFundDataMunicipal = projectPlanFundsByYear._embedded.length
        ? [
            projectPlanFundsByYear._embedded.map(
              (fund) => fund.municipalBudget || 0
            ),
          ]
        : [0];
      const planFundDataLocal = projectPlanFundsByYear._embedded.length
        ? [
            projectPlanFundsByYear._embedded.map(
              (fund) => fund.localBudget || 0
            ),
          ]
        : [0];
      const planFundLabels = projectPlanFundsByYear._embedded.map(
        (fund) => `${fund.year}`
      );
      project.projectPlanFundsByYear = projectPlanFundsByYear._embedded;
      project.projectPlanFundsDataFederal = planFundDataFederal;
      project.projectPlanFundsDataMunicipal = planFundDataMunicipal;
      project.projectPlanFundsDataLocal = planFundDataLocal;
      project.projectPlanFundsLabels = planFundLabels;
      project.planFundsOutside = projectPlanFundsByYear._embedded.reduce(
        (acc, fund) => acc + fund.ownBudget + fund.investorBudget || 0,
        0
      );
      return project;
    }

    function processDates(project) {
      if (project.planStartYear) {
        const year = project.planStartYear;
        const [day, month] = (project.planStartDate || "01.01").split(".");
        project.planStartYear = new Date(year, month - 1, day);
      }
      if (project.planEndYear) {
        const year = project.planEndYear;
        const [day, month] = (project.planEndDate || "01.01").split(".");
        project.planEndYear = new Date(year, month - 1, day);
      }
      return project;
    }

    async function init() {
      $scope.loading = true;
      $rootScope.title = "";
      loadMunicipalities(),
        loadIndustries(),
        loadMilestones().then(() => refresh());
    }
    // region Functions

    function toggleFilter() {
      $scope.isFilterOpen = !$scope.isFilterOpen;
    }

    function applyFilter(items) {
      ProjectGchpFilterService.setFilters(items);
      refresh();
    }

    function openCreateProject() {
      ProjectGchpService.create().result.then((data) => {
        ProjectGchpService.api.create(null, { form: data }, (data) => {
          ProjectGchpService.edit(data._embedded.id);
        });
      });
    }

    function loadMunicipalities() {
      return new Promise((resolve) => {
        MunicipalityService.api
          .get({
            filters: [`'status' EQ 'ENABLED'`],
            sorts: ["npp:ASC", "name:ASC"],
          })
          .$promise.then((data) => {
            $scope.municipalities = [
              {
                id: "none",
                name: "Не указано",
              },
            ].concat(data._embedded);
            $scope.municipalitiesObject = $scope.municipalities.reduce(
              (acc, red) => {
                const id = red.id;
                acc[id] = red;
                return acc;
              },
              {}
            );
            resolve();
          })
          .catch(() => ({}));
      });
    }

    function loadIndustries() {
      return new Promise((resolve) => {
        IndustryService.api
          .getAll({
            filters: [`'status' EQ '${EntityStatus.ENABLED}'`],
            sorts: ["name:ASC"],
          })
          .$promise.then((data) => {
            $scope.industries = [
              {
                id: "none",
                name: "Не указано",
              },
            ].concat(data._embedded);
            $scope.industriesObject = $scope.industries.reduce((acc, red) => {
              const id = red.id;
              acc[id] = red;
              return acc;
            }, {});
            resolve();
          })
          .catch(() => ({}));
      });
    }

    function loadMilestones() {
      return new Promise((resolve) => {
        MilestoneService.api.get({ sorts: ["npp:ASC", "name:ASC"] }, (data) => {
          $scope.milestones = [
            {
              id: null,
              name: "Все",
            },
          ].concat(data._embedded);
          resolve();
        });
      });
    }

    /**
     * Получение поиска
     * @returns {Array}
     */
    function getSearchs() {
      let searchs = [];
      if (
        $scope.pagination.search != null &&
        !($scope.pagination.search.length < 1)
      ) {
        searchs.push(
          `'shortName':'${$scope.pagination.search}'`,
          `'name':'${$scope.pagination.search}'`,
          `'code':'${$scope.pagination.search}'`,
          `'author.shortName':'${$scope.pagination.search}'`,
          `'author.fullName':'${$scope.pagination.search}'`
        );
      }

      return searchs;
    }

    /**
     * Обновить данные таблицы
     */
    function refresh(resetPagination = true) {
      if (resetPagination) {
        $scope.items = [];
        $scope.pagination.size = $scope.paginationSize;
      }
      let defaultMilestone = $scope.milestones.find(
        (el) => el.name === "Реализованные"
      );

      $scope.loading = true;

      //$scope.loading = false;
      ProjectGchpService.api.getAll(
        {
          filters: ProjectGchpFilterService.collectFilterDto({
            ...ProjectGchpFilterService.getFilters(),
            milestone: defaultMilestone ? defaultMilestone.id : undefined,
          }),
          searchs: getSearchs(),
          sorts: ["name:ASC"],
          page: $scope.pagination.page,
          size: $scope.pagination.size,
        },
        function (data) {
          $scope.items = data._embedded.items || [];
          if ($scope.pagination.isPaging && data.page) {
            $scope.pagination.totalPages = data.page.totalPages;
            $scope.pagination.totalItems = data.page.totalElements;
          }

          $scope.loading = false;
        }
      );
    }

    function oneMorePage() {
      if ($scope.pagination.size < $scope.pagination.totalItems) {
        $scope.pagination.size += $scope.paginationSize;
        refresh(false);
      }
    }

    $scope.$watch("pagination.search", (newValue, oldValue) => {
      if (oldValue !== newValue) {
        $scope.refresh();
      }
    });
  },
];
